<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" width="430px">
    <div class="mb10">
      <p class="text-center" style="font-weight: 700;">您的项目创建成功啦！</p>
      <p class="text-center" style="font-weight: 700;">
        继续完成以下操作，小阿才能帮你进行智能匹配哦，大大缩短你的搜寻时间！
      </p>
    </div>
    <div class="display-flex justify-center mb10">
      <el-button type="primary" size="mini" @click="confirm('continue')">继续完成项目信息</el-button>
      <el-button type="primary" size="mini" @click="confirm('complete')">创建完成</el-button>
    </div>
    <div class="display-flex justify-center mb10">
      <div class="cutoff-line"></div>
      <span>或者选择以下方式完善信息</span>
      <div class="cutoff-line"></div>
    </div>
    <div class="mb10">
      <div class="display-flex mb10" style="justify-content: flex-end;">
        <a @click="download({ url: `${host}/upload/项目信息模板.docx` })">下载项目创建模板</a>
      </div>
      <div class="display-flex" style="justify-content: space-around;">
        <div class="confirm-btn-box">
          <span class="mb5">从同公司项目克隆</span>
          <el-button type="primary" size="mini" plain @click="openCopyProject('同公司')">克隆项目</el-button>
        </div>
        <div class="confirm-btn-box">
          <span class="mb5">从同类岗位复制</span>
          <el-button type="primary" size="mini" plain @click="openCopyProject('同岗位')">克隆项目</el-button>
        </div>
        <div class="confirm-btn-box">
          <span class="mb5">已按模板线下填写</span>
          <el-button type="primary" size="mini" plain @click="showUpload">上传文件</el-button>
        </div>
      </div>
    </div>

    <!-- 组件 -->
    <copyProjectDialog ref="copyProjectDialog" @copyProject="confirmCopyProject"></copyProjectDialog>
    <UploadDialog ref="upload" :on-success="uploadSuccess" :type="fileType" :label="fileType" />
  </el-dialog>
</template>
<script>
import copyProjectDialog from './copyProject'
import { download, parseTemplateText } from '../../constant/utils'

export default {
  components: { copyProjectDialog },
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      dialogVisible: false,
      copyProject: {},
      company: {},
      industry: [],
      fileType: '附件',
    }
  },
  computed: {
    download() {
      return download
    },
  },
  watch: {
    project: {
      handler(newValue, oldValue) {
        this.copyProject = newValue
      },
      immediate: true,
    },
  },
  methods: {
    async open() {
      this.dialogVisible = true
    },
    showUpload() {
      this.$refs.upload.visible(true)
    },
    async uploadSuccess(response, file, fileList) {
      this.$refs.upload.visible()
      const res = response[0]
      this.parseTemplate(res)
    },
    async parseTemplate(file) {
      if (!file.originalname.match(/\.(docx|doc)$/)) return
      const res = await app.service('project').parseDocx(file)
      const json = parseTemplateText(res)
      Object.keys(json).forEach(field => {
        if (json[field]) this.$set(this.copyProject, field, json[field])
      })
      this.$message.success('编辑成功')
      this.$emit('next')
    },
    openCopyProject(type) {
      this.$refs.copyProjectDialog.open(type, this.project)
    },
    confirmCopyProject(project) {
      this.$emit('confirm', { type: 'copyProject', data: project })
      this.dialogVisible = false
    },
    confirm(type) {
      this.$emit('confirm', { type: type, data: null })
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped>
.display-flex {
  display: flex;
}
.cutoff-line {
  flex: 1;
  height: 1px;
  background-color: #c9c7c7;
  align-self: center;
}
.confirm-btn-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.confirm-btn-box span {
  font-size: 12px;
}
</style>
